import { render, staticRenderFns } from "./inspectionRecordsDetails.vue?vue&type=template&id=b57282ca&scoped=true&"
import script from "./inspectionRecordsDetails.vue?vue&type=script&lang=js&"
export * from "./inspectionRecordsDetails.vue?vue&type=script&lang=js&"
import style0 from "./inspectionRecordsDetails.vue?vue&type=style&index=0&id=b57282ca&lang=scss&scoped=true&"
import style1 from "./inspectionRecordsDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57282ca",
  null
  
)

export default component.exports